module.exports = __webpack_public_path__ + "static/media/partitions_material_60y_n.9736c6c3.csv";